module.exports = __webpack_public_path__ + "static/media/intra_oral_left.6d05ef5a.png";